import { UserGroupDetailsOutput } from './user-group-details-output.model';


export class UserGroupSelectByIdOutput implements IUserGroupSelectByIdOutput {
    status!: number;
    message!: string;
    data!: UserGroupDetailsOutput;

    constructor(data?: IUserGroupSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? UserGroupDetailsOutput.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserGroupSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUserGroupSelectByIdOutput {
    status: number;
    message: string;
    data: UserGroupDetailsOutput;
}

